module.exports = __webpack_public_path__ + "static/img/CgoRDGNXSO6AIG8AAAMUvbJO7gY470.f94dfcc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRDGNXSO6AIG8AAAMUvbJO7gY470.jpg
// module id = VZUK
// module chunks = 73